import useJwt from './jwt.js'
import axios from '@axios'

const { jwt } = useJwt(axios, {})
export default jwt
